module.exports = __webpack_public_path__ + "static/media/mojave-morning.5037b1f7.jpg";